import type { GlobalPickFilesOptions } from '@/scripts/hooks/usePickFile';
import type { Chat } from '../useChats/types';
import type { TransferState } from './file-sdk';
import type { useFileMessages } from '.';

export type UseFileMessages = ReturnType<typeof useFileMessages>;

export enum FileInfoStatus {
  ERROR = 1,
  CANCELED,
}

export interface FileInfo {
  name: string;
  size: number;
  type: string;
  ext: string;
  meta?: any;
  status?: number;
  width?: number;
  height?: number;
  thumbnail?: string;
}

export interface FileMessage {
  info: FileInfo;
  file: File | undefined;
  status: TransferState;
  progress: number;
  abortController: AbortController;
}

export type FileMessagePartial = Partial<FileMessage>;

export interface PickInfo {
  chat: Chat;
  options?: GlobalPickFilesOptions;
}

export type PickInfoPartial = Partial<PickInfo>;

export interface FileMessagesState {
  map: Record<string, FileMessage>;
  pickInfo: PickInfo | undefined;
}

export type FileMessagesStatePartial = Partial<FileMessagesState>;

export type FileMessageMapPartial = Record<string, FileMessagePartial>;

export type FileMessagesActions =
  | {
      type: 'updateFileMessages';
      payload: FileMessageMapPartial;
    }
  | {
      type: 'removeFileMessage';
      payload: string;
    }
  | {
      type: 'getFileMessage';
      payload: string;
      cb: (fm: FileMessage) => void;
    }
  | {
      type: 'updatePickInfo';
      payload: PickInfoPartial;
    }
  | {
      type: 'removePickInfo';
    };
